import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

const url = "https://apicontrol.softcom.es/api/"
const urlLocal = "https://localhost:5001/api/"
const http = axios.create({
  baseURL: url
});

Vue.use(VueAxios, http);
